import { webApi } from './index';

export default {
  getProvinceList() {
    return webApi.get('/shippings/provinces');
  },

  getCityList(provinceId) {
    return webApi.get(`/shippings/provinces/${provinceId}/cities`);
  },
};
